import { render } from "./refugedescriVue.vue?vue&type=template&id=81752190&scoped=true"
const script = {}

import "./refugedescriVue.vue?vue&type=style&index=0&id=81752190&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81752190"]])

export default __exports__